import type { CycleOperatorSummary } from "./types";

export function summarizePortfolioCouplingLine(cycle?: CycleOperatorSummary | null): string | null {
  const pc = cycle?.portfolioCoupling;
  if (!pc) return null;
  const parts: string[] = [];
  if (pc.intentsTotal != null) parts.push(`intents ${pc.intentsTotal}`);
  if (pc.burstsGte5 != null) parts.push(`burst≥5 ${pc.burstsGte5}`);
  if (pc.burstCap4Over != null) parts.push(`cap4+ ${pc.burstCap4Over}`);
  if (pc.roundTripNetBps != null) parts.push(`RT ${pc.roundTripNetBps.toFixed(1)}bps`);
  if (parts.length === 0) return null;
  return parts.join(" · ");
}
